<template>
  <div>
    <v-container :class="{'py-10': $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl, 'py-6': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs}">
      <h1 :class="{'text-center mb-6': $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl, 'text-center mb-4 mt-4': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs}">Оферта</h1>

      <v-card class="mb-6">
        <v-card-text>
          <div class="pdf-container">
            <object
                :data="ofertaUrl"
                type="application/pdf"
                width="100%"
                :height="pdfHeight"
            >
              <p>
                Ваш браузер не підтримує вбудовані PDF-файли.
                <a :href="ofertaUrl" target="_blank" download="Оферта_ТОВ_СОРФ_ЕнергоБали.pdf">
                  Натисніть тут, щоб завантажити файл
                </a>
              </p>
            </object>
          </div>
        </v-card-text>
      </v-card>

      <v-row justify="center" class="mt-6">
        <v-col cols="12" class="text-center mb-4">
          <v-btn
              large
              outlined
              rounded
              :to="'/pricing'"
              class="blue_btn px-12 py-4 action-btn"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            <span class="blue_btn_text">Повернутися до цін</span>
          </v-btn>
        </v-col>
        <v-col cols="12" class="text-center mb-4">
          <v-btn
              large
              outlined
              rounded
              :href="ofertaUrl"
              target="_blank"
              download="Оферта_ТОВ_СОРФ_ЕнергоБали.pdf"
              class="yellow_btn px-12 py-4 action-btn"
          >
            <v-icon left>mdi-download</v-icon>
            <span class="yellow_btn_text">Завантажити оферту</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Oferta",
  data: () => ({
    ofertaUrl: '/oferta.pdf'
  }),
  computed: {
    pdfHeight() {
      // Адаптивная высота для PDF-просмотрщика
      if (this.$vuetify.breakpoint.xs) {
        return '500px';
      } else if (this.$vuetify.breakpoint.sm) {
        return '600px';
      } else {
        return '800px';
      }
    }
  }
}
</script>

<style scoped>
h1 {
  font-family: 'Artega Sans', sans-serif;
  color: #0F0C56;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.2;
}

.pdf-container {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.yellow_btn {
  background: transparent;
  border: 1px solid #0F0C56;
}

.yellow_btn:hover {
  border: 1px solid #FCBD22;
  background: linear-gradient(92.46deg, #FBA802 16.53%, #FCBD22 55.38%, #FBCD39 98.62%) !important;
  box-shadow: 0px 0px 7px 4px rgba(252, 170, 6, 0.3);
}

.yellow_btn_text {
  font-family: 'Artega Sans', sans-serif;
  color: #0F0C56;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.22;
}

.yellow_btn:hover .yellow_btn_text {
  color: #fff;
}

.blue_btn {
  background: transparent;
  border: 1px solid #0F0C56;
}

.blue_btn:hover {
  border: 1px solid #0F0C56;
  background: linear-gradient(92.46deg, #0F0C56 16.53%, #2C288A 55.38%, #3F3BB5 98.62%) !important;
  box-shadow: 0px 0px 7px 4px rgba(15, 12, 86, 0.3);
}

.blue_btn_text {
  font-family: 'Artega Sans', sans-serif;
  color: #0F0C56;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.22;
}

.blue_btn:hover .blue_btn_text {
  color: #fff;
}

.pdf-viewer {
  width: 100%;
  height: 80vh;
  border: none;
}

@media (max-width: 600px) {
  .pdf-viewer {
    height: 70vh;
  }
}

.action-btn {
  width: 280px;
  max-width: 100%;
}
</style>
